<template>
</template>
<script type="text/javascript">
const province_area =[

]



export default{
  province_area
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/const/PROVINCE.vue